import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DELIVERED_QUANTITY_LABEL } from '@/common/constants';
import { useAuth } from '@/common/contexts/AuthContext';

const useProduct = ({
  deliverableQuantity,
  deliveredQuantity,
  deliveredQuantityLabel,
  orderedQuantity,
  productId,
  returnedQuantity,
}) => {
  const { t } = useTranslation();
  const { user } = useAuth();

  const getProductId = useMemo(() => {
    if (productId.startsWith(`${user.company_code}_`)) {
      return productId.split(`${user.company_code}_`)[1];
    }

    return productId;
  }, [productId, user]);

  const getDeliveredQuantityLabel = useMemo(() => {
    if (
      returnedQuantity > 0 &&
      deliveredQuantityLabel !== DELIVERED_QUANTITY_LABEL.RETURNED
    ) {
      return (
        <ul className="list">
          <li className="item">
            {t('ebat:entities:order.delivered_quantity_label.sold')}
            {deliveredQuantity}
          </li>
          <li className="item">
            {t('ebat:entities:order.delivered_quantity_label.returned')}
            {returnedQuantity}
          </li>
        </ul>
      );
    }

    return deliveredQuantityLabel;
  }, [deliveredQuantity, deliveredQuantityLabel, returnedQuantity, t]);

  const getSelectedQuantity = useMemo(() => {
    if (deliveredQuantity > 0) {
      return orderedQuantity - deliveredQuantity;
    }

    if (orderedQuantity === deliveredQuantity) {
      return orderedQuantity;
    }

    return deliverableQuantity;
  }, [deliverableQuantity, deliveredQuantity, orderedQuantity]);

  return {
    getDeliveredQuantityLabel,
    getProductId,
    getSelectedQuantity,
  };
};

export default useProduct;
